<template>
  <div>
    <el-form
      ref="searchInfo"
      :model="searchInfo"
      class="global-form"
      :inline="true"
    >
      <el-form-item>
        <el-select
          v-model="searchInfo.projectId"
          placeholder="请选择项目"
          filterable
          clearable
        >
          <el-option
            v-for="item in projectList"
            :key="item.projectId"
            :label="item.projectName"
            :value="item.projectId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="searchInfo.teamName"
          clearable
          placeholder="请输入班组名称"
        />
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="searchInfo.attendanceDate"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="请选择考勤日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="medium" @click="onSearch"
          >查询</el-button
        >
      </el-form-item>
    </el-form>
    <div>
      <!-- <el-button class="mb20" type="primary" @click="onExport" v-show="$ButtonShow('YWK_SEL_10')">
          <div class="importExport">
            <svg class="global-icon" aria-hidden="true">
              <use :xlink:href="'#icon-icon_obj_daochu'"></use>
            </svg>
            <span>导出</span>
          </div>
        </el-button> -->
      <el-button
        class="btn"
        type="primary"
        v-show="$ButtonShow('YTA_SEL_03')"
        icon="el-icon-plus"
        @click="goCorrect"
        >修正记录</el-button
      >
    </div>
    <el-table
      ref="table"
      class="global-table"
      stripe
      v-loading="loading"
      :data="tableData"
    >
      <el-table-column
        label="班组名称"
        min-width="100px"
        show-overflow-tooltip
        prop="teamName"
      >
      </el-table-column>
      <el-table-column
        label="项目名称"
        min-width="100px"
        show-overflow-tooltip
        prop="projectName"
      >
      </el-table-column>
      <el-table-column
        label="考勤日期"
        min-width="100px"
        show-overflow-tooltip
        prop="attendanceDate"
      >
      </el-table-column>
      <el-table-column
        label="上班签到人数"
        min-width="100px"
        show-overflow-tooltip
        prop="onSignNum"
      >
      </el-table-column>
      <el-table-column
        label="下班签到人数"
        min-width="100px"
        show-overflow-tooltip
        prop="offSignNum"
      >
      </el-table-column>
      <el-table-column
        label="签到情况"
        min-width="100px"
        show-overflow-tooltip
        prop="signStatus"
      >
        <template v-slot="{ row }">
          <div style="display: flex; align-items: center">
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">{{ row.signStatus | getStatusName2 }}</div>
              <span>{{ row.signStatus | getStatusName }}</span>
            </el-tooltip>
            <img
              v-if="row.signStatus !== '1'"
              :src="require('@/assets/img/attendance/exclamationPoint.svg')"
              alt=""
              srcset=""
              style="margin-left: 5px"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="加班总时长"
        min-width="100px"
        show-overflow-tooltip
        prop="totalOvertimeHours"
      >
      </el-table-column>
      <el-table-column
        label="加班人数"
        min-width="100px"
        show-overflow-tooltip
        prop="overtimeNum"
      >
      </el-table-column>
      <el-table-column
        label="加班备注"
        min-width="100px"
        show-overflow-tooltip
        prop="overtimeRemark"
      >
      </el-table-column>
      <el-table-column label="操作" width="180px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" @click="onDetail(row.attendanceId)"
            >查看</el-button
          >
          <el-button
            type="text"
            v-show="$ButtonShow('YTA_EDT_01')"
            @click="onCorrect(row.attendanceId)"
            >修正</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <global-pagination
      :total="total"
      :current-page.sync="page"
      :page-size.sync="size"
      @current-change="loadData"
      @size-change="loadData"
    ></global-pagination>
    <Details :detailsShow.sync="detailsShow" :id.sync="detailsId"></Details>
    <Correct
      @success="loadData"
      :correctShow.sync="correctShow"
      :id.sync="correctId"
    ></Correct>
  </div>
</template>

<script>
import Details from "./TeamsDetails.vue";
import Correct from "./TeamsCorrect.vue";

// @KeepAlive
export default {
  name: "TeamsList",
  components: {
    Details,
    Correct,
  },
  data() {
    return {
      searchInfo: {
        projectId: "",
        attendanceDate: "",
        teamName: "",
      },

      total: 0,
      page: 1,
      size: 10,
      loading: false,
      tableData: [],

      detailsId: "",
      detailsShow: false,

      correctId: "",
      correctShow: false,
    };
  },
  computed: {
    projectList() {
      return this.$store.state.projectList;
    },
  },
  filters: {
    getStatusName: function (value) {
      // 签到状态 1正常 2缺上班签到 3缺下班签到 4上下班人数不一致
      if (value) {
        if (value === "1") {
          return "正常";
        } else {
          return "异常";
        }
      }
    },
    getStatusName2: function (value) {
      if (value) {
        if (value === "1") {
          return "正常";
        } else if (value === "2") {
          return "缺上班签到";
        } else if (value === "3") {
          return "缺下班签到";
        } else if (value === "4") {
          return "上下班人数不一致";
        } else {
          return "--";
        }
      }
    },
  },

  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      // console.log('loadData')
      this.loading = true;
      this.$axios
        .get(this.$apis.laborManage.selectYhTeamAttendanceByPage, {
          ...this.searchInfo,
          page: this.page,
          size: this.size,
        })
        .then((res) => {
          this.tableData = res.list || [];
          this.total = res.total || 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onSearch() {
      this.page = 1;
      this.loadData();
    },

    onExport() {
      const loading = this.$loading({
        lock: true,
        text: "下载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios
        .downloadFile(
          this.$apis.recruitUse.exportWorkerDutyCount,
          this.searchInfo
        )
        .finally(() => {
          loading.close();
        });
    },

    onDetail(id) {
      this.detailsId = id;
      this.detailsShow = true;
    },

    onCorrect(id) {
      this.correctId = id;
      this.correctShow = true;
    },

    goCorrect() {
      this.$router.push({
        name: "correct",
      });
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .card-main {
  padding: 0 !important;
}

::v-deep .el-card__body {
  padding: 0 !important;
}

.main {
  width: 100%;
  padding: 20px 40px;
  border-top: 1px solid #f4f4f4;
}

.btn {
  margin-bottom: 10px;
}
</style>
